import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H5 } from "../../../../../AbstractElements";
import { VisitorsTitle } from "../../../../../Constants/Constants";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { CommonDropdown } from "../../../../CommonComponents/CommonDropdown/CommonDropdown";
import ReactApexChart from "react-apexcharts";
import { VisitorsChart } from "../../../../../Data/General/Widgets/General";

const Visitors = () => {
  return (
    <Col xl="6" md="12">
      <Card className="visitor-card">
        <CardHeader className="card-no-border pb-0">
          <div className="header-top">
            <H5 className="f-w-600 m-0">
              {VisitorsTitle}
              <span className="f-14 font-primary f-w-500 ms-1">
                <SvgIcon className="svg-fill me-1" iconId="user-visitor" />
                (+2.8)
              </span>
            </H5>
            <CommonDropdown dropdownClass="dropdown-toggle" />
          </div>
        </CardHeader>
        <CardBody className="pt-3">
          <div className="visitors-container">
            <div id="visitors-chart">
                <ReactApexChart options={VisitorsChart} series={VisitorsChart.series} height={220} type="bar"/>
             </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Visitors;
